import React from 'react'
import PropTypes from 'prop-types'

import styles from './formGrid.module.scss'

const FormGrid = (props) => {
  return <div className={styles.formGrid}>{props.children}</div>
}

FormGrid.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]).isRequired,
}

export { FormGrid }
